import React from 'react';
import { connect } from 'react-redux';
import CancelRequest from './CancelRequest.frame';
import { openCancelRequestModal } from './redux/openCancelRequestModal';
import { onCancelReasonTypeChange } from './redux/onCancelReasonTypeChange';
import { onDetailsChange } from './redux/onDetailsChange';
import { asyncCancelRequest } from './redux/actions';
import { fetchRequestReasonTypes } from './redux/fetchRequestReasonTypes';
import { menuCancelDisabled, showDetailsQuestion, cancelDisabled, cancelRestricted } from './CancelRequest.flags';

const CancelRequestContainer = props => <CancelRequest {...props} />;

function tmoPhoneNumber(state) {
  const phone = state.agency.requesterAgencyGroup?.tmoPhoneNumber;
  return phone && phone.trim().length > 0 ? phone : null;
}

function mapStateToProps(state) {
  return {
    menuCancelDisabled: menuCancelDisabled(state),
    showDetailsQuestion: showDetailsQuestion(state),
    cancelDisabled: cancelDisabled(state),
    cancelRestricted: cancelRestricted(state),
    tmoPhoneNumber: tmoPhoneNumber(state),
    isPrimary: state.requests.request.id === state.requests.primaryRequestId,
    isAssist: state.requests.request.id === state.requests.assistRequestId,
    ...state.cancelRequest,
  };
}

export default connect(mapStateToProps, {
  openCancelRequestModal,
  asyncCancelRequest,
  onDetailsChange,
  fetchRequestReasonTypes,
  onCancelReasonTypeChange,
})(CancelRequestContainer);
